import { getRequest } from '../services/requestHandler';
import { SwingWtPrefix } from '../models';

//5537, 3 for testing
export const getSwingWtPrefix = async () => {
  const url = `swingwt/getSwingWtPrefix?activeOnly=true`;
  const response = await getRequest<SwingWtPrefix>('GetSwingWtPrefix', url);
  return response;
};
